import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "focus:outline-none;",
  ref: "fakeInput",
  style: {"width":"0px","height":"0px"}
}
const _hoisted_2 = { class: "flex items-center justify-center" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  class: "mt-8 grid w-full",
  style: {"grid-template-columns":"repeat(auto-fit, minmax(160px, 1fr))","grid-gap":"0.75rem"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("ปิดหน้าต่าง")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_CommonModal = _resolveComponent("CommonModal")!

  return (_openBlock(), _createBlock(_component_CommonModal, {
    class: "common-modal-with-preset",
    ref: "modal",
    medium: "",
    hideClose: _ctx.hideClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Panel, {
        title: _ctx.preset.title
      }, {
        float: _withCtx(() => [
          _createElementVNode("input", _hoisted_1, null, 512)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.type === 'confirm-logout')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
              : _createCommentVNode("", true),
            (_ctx.type === 'confirm-delete')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
              : _createCommentVNode("", true),
            (_ctx.type === 'success')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
              : _createCommentVNode("", true),
            (_ctx.type === 'success-close')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [], 64))
              : _createCommentVNode("", true),
            (_ctx.type === 'login-failed' || _ctx.type === 'wrong-password' || _ctx.type === 'missing' || _ctx.type === 'failed')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [], 64))
              : _createCommentVNode("", true),
            (_ctx.type === 'contact-help')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [], 64))
              : _createCommentVNode("", true),
            (_ctx.type === 'upload-failed')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [], 64))
              : _createCommentVNode("", true)
          ]),
          (_ctx.preset.titleBody)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["text-3xl text-center", _ctx.preset.titleBodyClass || 'text-primary-500'])
              }, _toDisplayString(_ctx.preset.titleBody), 3))
            : _createCommentVNode("", true),
          _createElementVNode("p", {
            class: "text-center my-2 text-gray-800 text-lg",
            innerHTML: _ctx.context.body || _ctx.preset.body
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.type !== 'missing' && _ctx.type !== 'success-close' && _ctx.type !== 'contact-help' && _ctx.type !== 'wrong-password' && _ctx.type !== 'failed' && _ctx.type !== 'upload-failed')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  ('secondaryDone' in _ctx.$attrs)
                    ? (_openBlock(), _createBlock(_component_CommonButton, {
                        key: 0,
                        block: "",
                        level: "gray-border",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.secondary()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.context.secondaryAction), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_CommonButton, {
                        key: 1,
                        block: "",
                        level: "gray-border",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.context.dismiss), 1)
                        ]),
                        _: 1
                      }))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              (_ctx.type === 'missing' || _ctx.type === 'success-close' || _ctx.type === 'contact-help' || _ctx.type === 'wrong-password' || _ctx.type === 'failed' || _ctx.type === 'upload-failed')
                ? (_openBlock(), _createBlock(_component_CommonButton, {
                    key: 0,
                    block: "",
                    level: _ctx.preset.actionColor,
                    type: "submit",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["level"]))
                : (_ctx.type === 'confirm-delete')
                  ? (_openBlock(), _createBlock(_component_CommonButton, {
                      key: 1,
                      block: "",
                      level: _ctx.preset.actionColor,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.done()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.context.action) + _toDisplayString(_ctx.context.entity), 1)
                      ]),
                      _: 1
                    }, 8, ["level"]))
                  : (_openBlock(), _createBlock(_component_CommonButton, {
                      key: 2,
                      block: "",
                      level: _ctx.preset.actionColor,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.done()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.context.primaryAction || _ctx.context.action), 1)
                      ]),
                      _: 1
                    }, 8, ["level"]))
            ])
          ])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }, 8, ["hideClose"]))
}